import { Chart, registerables } from "chart.js";
import { buildChartConfig, type OrganizationRequestsData } from "./buildChartConfig";

Chart.register(...registerables);

type Inputs = {
  canvasElement: HTMLCanvasElement;
  data: OrganizationRequestsData;
};

export function initOrganizationRequestsChart({ canvasElement, data }: Inputs): Chart {
  return new Chart(canvasElement, buildChartConfig(data));
}
